import { render, staticRenderFns } from "./LoginPC.vue?vue&type=template&id=467c9588&scoped=true&"
import script from "./LoginPC.vue?vue&type=script&lang=js&"
export * from "./LoginPC.vue?vue&type=script&lang=js&"
import style0 from "./LoginPC.vue?vue&type=style&index=0&id=467c9588&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467c9588",
  null
  
)

component.options.__file = "LoginPC.vue"
export default component.exports